import React from 'react';
import { createRoot } from 'react-dom/client';

import { BookingForm } from '../main-app/components/BookingForm';

const node = document.getElementById('vv-booking-form__form');
if (node) {
  document.addEventListener('DOMContentLoaded', () => {
    const examCenterType = node.getAttribute('data-exam-center');
    const examCenterTimezone = node.getAttribute('data-exam-center-timezone');
    const examCenterId = node.getAttribute('data-exam-center-site-id');
    const reviewsCount = +node.getAttribute('data-reviews_count');
    const averageStars = +node.getAttribute('data-average_stars');

    const root = createRoot(node);
    root.render(
      <BookingForm
        examCenter={examCenterType}
        examCenterSiteId={examCenterId}
        reviewsCount={reviewsCount}
        averageStars={averageStars}
        examCenterTimezone={examCenterTimezone}
      />,
    );
  });
}
